import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import swimmingCover from "../../../Assets/Hompage/Swimming/swimming-cover.jpeg";
import swimmingCoverMobile from "../../../Assets/Hompage/Swimming/Swimming1 (1).jpeg";
import swimming from "../../../Assets/Hompage/Swimming/Swimming1 (2).jpeg";
import swimming1 from "../../../Assets/Hompage/Swimming/Swimming1 (1).jpeg";
import swimming2 from "../../../Assets/Hompage/Swimming/Swimming1 (3).jpeg";
import swimming3 from "../../../Assets/Hompage/Swimming/Swimming1 (4).jpeg";

const SwimmingPool = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <div>
      <div className="bg-gray-100">
        <div className="pt-16 md:pt-0 md:block hidden">
          <img src={swimmingCover} alt="Swimming" className="w-full" />
        </div>
        <div className="pt-16 md:pt-0 md:hidden block">
          <img src={swimmingCoverMobile} alt="Swimming" className="w-full" />
        </div>
        <div className="max-w-screen-xl mx-auto">
          <div className="py-10 md:px-20 px-5 bg-white">
            <h2 className="text-[50px] text-gray-800 md:text-start text-center">
              Swimming Pool
            </h2>

            <div className="py-20">
              <p className="text-[16px]">
                Our resort is designed to provide a luxurious and relaxing
                experience for all our guests. Here, you can enjoy not one, but
                two stunning swimming pools! For the adults, we have a spacious
                crystal clear swimming pool that is perfect for taking a
                refreshing dip on a hot day. You can take a swim anytime here
                that provides the perfect atmosphere for relaxation. For our
                younger guests, we have a separate swimming pool just for kids.
                The pool is designed with their safety in mind, and the water is
                shallow enough for children to play in with ease. The pool is
                also well-maintained and cleaned regularly to ensure a hygienic
                environment for your little ones.
              </p>
            </div>
          </div>

          <div className="px-5 md:px-0">
            <Carousel
              responsive={responsive}
              infinite={true}
              autoPlaySpeed={2000}
              autoPlay={true}
              customTransition="all .5"
            >
              <div>
                <img src={swimming} alt="Swimming" className="w-full" />
              </div>
              <div>
                <img src={swimming1} alt="Swimming" className="w-full" />
              </div>
              <div>
                <img src={swimming2} alt="Swimming" className="w-full" />
              </div>
              <div>
                <img src={swimming3} alt="Swimming" className="w-full" />
              </div>
            </Carousel>
          </div>
          <div className="py-20">
            <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
              <div className="flex justify-center items-start"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwimmingPool;
